import { hasSecretPath, scrubRoute } from "../clientErrors/clientErrorReporter";

/** Query parameters that carry a one-time token (Zoho's ?confirm=). */
const SECRET_PARAMS = ["confirm"];

/** True when the address holds a token, in the path (/a/<token>, /orders/confirm/<token>) or the query. */
export const hasSecretInAddress = (pathname: string, search: string): boolean =>
  hasSecretPath(pathname) || SECRET_PARAMS.some((key) => new URLSearchParams(search).has(key));

/** The page as Google Analytics may see it: secret path segments masked, secret parameters dropped. */
export const analyticsPage = (pathname: string, search: string): string => {
  const params = new URLSearchParams(search);
  SECRET_PARAMS.forEach((key) => params.delete(key));
  const query = params.toString();
  const path = hasSecretPath(pathname) ? scrubRoute(pathname) : pathname;
  return path + (query ? `?${query}` : "");
};
